/**
 * https://www.figma.com/file/7Gfry5KCHWtM3ur73RKhMu/Question-Indexing-UI?node-id=420%3A5147
 */

import classNames from "classnames";
import React, { ReactElement } from "react";
import styles from "./cta.module.scss";
import { useTranslation } from "next-i18next";
import { useAppContext } from "@kunduz/feature-website-context";
import { trackEvent } from "@kunduz/utility-analytics";
import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useStudentLimits } from "@kunduz/data-access-core-api";

const GoUnlimitedCta = (props: Props): ReactElement => {
  const { t } = useTranslation("questionIndexing");
  const { student, kunduzApiToken } = useAppContext();
  const { studentLimits } = useStudentLimits(kunduzApiToken);

  function onSeePlansClicked() {
    const plan_type = !student.data?.primary_package
      ? "freemium"
      : student.data?.primary_package?.package.is_recurring
        ? "monthly"
        : "unlimited";

    trackEvent("Question Indexing See Plans Button Clicked", {
      course: props.question.course.slug,
      subject: props.question.subject.slug,
      page_slug: window.location.pathname,
      remaining_answer_credit: studentLimits?.questions?.remained,
      initial_answer_credit: studentLimits?.questions?.total,
      plan_type,
      type: "context",
      persona: undefined,
    });
  }

  return (
    <div className={styles.goUnlimited}>
      <div>
        <p className={styles.title}>
          {t(
            "question_indexing_answer_component_purchase_plan_state_primary_proposition_text",
          )}
        </p>
        <p className={styles.desc}>
          {t(
            "question_indexing_answer_component_purchase_plan_state_secondary_proposition_text",
          )}
        </p>
      </div>
      <div className={classNames(styles.rightColumn)}>
        <a
          href={t("ask_question_modal_ask_question_button_no_credits_url_copy")}
          target="_blank"
          rel="noreferrer"
          className={styles.ctaButton}
          onClick={onSeePlansClicked}
        >
          <UnlimitedIcon />
          <span>
            {t(
              "question_indexing_answer_component_purchase_plan_state_cta_label",
            )}
          </span>
        </a>
      </div>
    </div>
  );
};

function UnlimitedIcon() {
  return (
    <svg
      width="29"
      height="15"
      viewBox="0 0 29 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7823 11.106C17.3607 11.8838 18.1001 12.5277 18.95 12.9937C19.8 13.4597 20.7404 13.7369 21.7073 13.8063C23.3798 13.8063 24.9839 13.1419 26.1665 11.9592C27.3492 10.7766 28.0136 9.17252 28.0136 7.49997C28.0136 5.82742 27.3492 4.22337 26.1665 3.04069C24.9839 1.85802 23.3798 1.1936 21.7073 1.1936C17.2027 1.1936 14.5 7.49997 14.5 7.49997C14.5 7.49997 11.7973 13.8063 7.29272 13.8063C5.62017 13.8063 4.01612 13.1419 2.83345 11.9592C1.65078 10.7766 0.986359 9.17252 0.986359 7.49997C0.986359 5.82742 1.65078 4.22337 2.83345 3.04069C4.01612 1.85802 5.62017 1.1936 7.29272 1.1936C8.2598 1.26414 9.20032 1.54228 10.0502 2.0091C10.9001 2.47591 11.6394 3.12043 12.2177 3.89873"
        stroke="#1A1F1F"
        strokeWidth="1.80182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface Props {
  question: QuestionIndexing.TrQiQuestion;
}

export default GoUnlimitedCta;
